import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cc-confirm-body"
};
const _hoisted_2 = { class: "cc-confirm-question" };
const _hoisted_3 = { class: "cc-confirm-buttons" };
const _hoisted_4 = {
    key: 1,
    class: "cc-categories"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
    key: 2,
    class: "cc-tags-box"
};
const _hoisted_8 = { class: "cc-tags-wrap" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
    key: 3,
    class: "cc-tag-section"
};
const _hoisted_11 = {
    key: 0,
    class: "cc-footer"
};
const _hoisted_12 = { class: "cc-toggles" };
const _hoisted_13 = { class: "cc-confirm-button" };
import { ref, computed, watch, onMounted } from 'vue';
import SimpleDrawerPanel from './SimpleDrawerPanel.vue';
import MGButton from './MGButton.vue';
import MGToggle from './MGToggle.vue';
import TagInput from './TagInput.vue';
import { getTransactionClassificationTree } from '@/composables/useSpendingAnalysis';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChangeCategoryDrawer',
    props: {
        merchantName: {},
        currentClassification: {},
        currentExcludeFromAnalysis: { type: Boolean },
        selectableTags: {},
        currentTags: {}
    },
    emits: ["apply", "tag-change"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isOpen = ref(false);
        const selectedCategory = ref(null);
        const selectedTag = ref(null);
        const initialTag = ref(null);
        const alwaysApply = ref(false);
        const excludeFromAnalysis = ref(false);
        const alwaysApplyExcludeInclude = ref(false);
        const excludeDialogVisible = ref(false);
        const initialAlwaysApply = ref(false);
        const initialExcludeFromAnalysis = ref(false);
        const selectedTags = ref([]);
        const initialTags = ref([]);
        function tagsChanged(a, b) {
            if (a.length !== b.length)
                return true;
            const sa = [...a].sort();
            const sb = [...b].sort();
            return sa.some((v, i) => v !== sb[i]);
        }
        const categoryChanged = computed(() => {
            return !!selectedTag.value && selectedTag.value !== initialTag.value;
        });
        watch(categoryChanged, (changed) => {
            if (!changed)
                alwaysApply.value = false;
        });
        const hasChanges = computed(() => {
            if (!selectedTag.value)
                return false;
            if (selectedTag.value !== initialTag.value)
                return true;
            if (alwaysApply.value !== initialAlwaysApply.value)
                return true;
            if (excludeFromAnalysis.value !== initialExcludeFromAnalysis.value)
                return true;
            return false;
        });
        function handleTagsChange(tags) {
            selectedTags.value = tags;
            emit('tag-change', tags);
        }
        const categories = ref([]);
        function resolveIconPath(iconPath) {
            if (!iconPath)
                return null;
            try {
                return require('@/assets/transactions/' + iconPath.toLowerCase().replace('.svg', '.png'));
            }
            catch {
                return null;
            }
        }
        const CATEGORY_ORDER = ['Income', 'Essentials', 'Lifestyle', 'Future', 'General'];
        function buildCategories(tree) {
            const parents = Array.isArray(tree?.parents) ? [...tree.parents] : [];
            parents.sort((a, b) => {
                const ai = CATEGORY_ORDER.indexOf(a.name);
                const bi = CATEGORY_ORDER.indexOf(b.name);
                return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
            });
            return parents.filter((p) => Array.isArray(p.subClassifications) && p.subClassifications.length > 0).map((p) => {
                const subs = Array.isArray(p.subClassifications) ? p.subClassifications : [];
                const parentIcon = resolveIconPath(`${p.name}.svg`);
                const fallbackIcon = p.iconPath ?? subs.find((s) => s.iconPath)?.iconPath;
                const tags = subs
                    .map((s) => ({ name: s.mgSubClassification || s.mgClassification, classification: s }))
                    .filter((t) => !!t.name);
                return {
                    key: p.name,
                    label: p.name,
                    colour: p.color,
                    iconPath: parentIcon ?? resolveIconPath(fallbackIcon),
                    tags,
                };
            }).filter((c) => c.tags.length > 0);
        }
        onMounted(() => {
            getTransactionClassificationTree((tree) => {
                categories.value = buildCategories(tree);
            });
        });
        const selectedCategoryData = computed(() => {
            if (!selectedCategory.value)
                return null;
            return categories.value.find(c => c.key === selectedCategory.value) ?? null;
        });
        const displayTags = computed(() => {
            const tags = selectedCategoryData.value?.tags ?? [];
            return [...tags].sort((a, b) => {
                if (a.name === 'Other' && b.name !== 'Other')
                    return 1;
                if (a.name !== 'Other' && b.name === 'Other')
                    return -1;
                return a.name.localeCompare(b.name);
            });
        });
        function selectCategory(key) {
            selectedCategory.value = key;
            selectedTag.value = null;
        }
        const selectedTagData = ref(null);
        function selectTag(tag) {
            selectedTag.value = tag.name;
            selectedTagData.value = tag;
        }
        function tagDotColour(tag) {
            return tag.classification?.color ?? selectedCategoryData.value?.colour ?? '#413655';
        }
        function resetState() {
            selectedCategory.value = null;
            selectedTag.value = null;
            selectedTagData.value = null;
            initialTag.value = null;
            alwaysApply.value = false;
            excludeFromAnalysis.value = false;
            alwaysApplyExcludeInclude.value = false;
            excludeDialogVisible.value = false;
            initialAlwaysApply.value = false;
            initialExcludeFromAnalysis.value = false;
            selectedTags.value = [];
            initialTags.value = [];
        }
        const revertingExclude = ref(false);
        watch(excludeFromAnalysis, () => {
            if (!isOpen.value)
                return;
            if (revertingExclude.value) {
                revertingExclude.value = false;
                return;
            }
            alwaysApplyExcludeInclude.value = false;
            excludeDialogVisible.value = true;
        });
        function confirmAlwaysExcludeInclude(always) {
            alwaysApplyExcludeInclude.value = always;
            excludeDialogVisible.value = false;
        }
        function cancelExcludeChange() {
            revertingExclude.value = true;
            excludeFromAnalysis.value = !excludeFromAnalysis.value;
            excludeDialogVisible.value = false;
        }
        // Pre-select the category + tag matching the transaction's current classification.
        // Re-runs if the tree loads after the drawer opens, or if the classification changes
        // between opens. "Always apply" and "Exclude" stay off — they represent new intent.
        function applyPreselection() {
            if (!isOpen.value)
                return;
            if (!categories.value.length)
                return;
            const c = props.currentClassification;
            if (!c)
                return;
            const subName = c.mgSubClassification || c.mgClassification;
            if (!subName)
                return;
            // Prefer matching by parent + sub when both are available — "Other" / "Uncategorised"
            // exist under multiple parents, so a sub-only lookup picks the wrong one
            // (Income gets matched first because of CATEGORY_ORDER).
            const parentName = c.mgSubClassification ? c.mgClassification : null;
            const parent = (parentName && categories.value.find(cat => cat.key === parentName && cat.tags.some(t => t.name === subName)))
                || categories.value.find(cat => cat.tags.some(t => t.name === subName));
            if (!parent)
                return;
            const tag = parent.tags.find(t => t.name === subName) ?? null;
            selectedCategory.value = parent.key;
            selectedTag.value = tag?.name ?? null;
            selectedTagData.value = tag;
            initialTag.value = tag?.name ?? null;
        }
        // Reset state when drawer closes; re-apply pre-selection when it opens.
        watch(isOpen, (open) => {
            if (!open) {
                resetState();
                return;
            }
            const initialExclude = props.currentExcludeFromAnalysis ?? false;
            if (excludeFromAnalysis.value !== initialExclude) {
                revertingExclude.value = true;
                excludeFromAnalysis.value = initialExclude;
            }
            initialExcludeFromAnalysis.value = initialExclude;
            initialAlwaysApply.value = false;
            const startTags = Array.isArray(props.currentTags) ? [...props.currentTags] : [];
            selectedTags.value = startTags;
            initialTags.value = [...startTags];
            applyPreselection();
        });
        // If the classification tree loads after the drawer opened, apply once it arrives.
        watch(categories, () => {
            if (isOpen.value)
                applyPreselection();
        });
        // If the parent's customer tags arrive after the drawer opened (e.g. transaction
        // finished loading), pick them up — provided the user hasn't started editing yet.
        watch(() => props.currentTags, (next) => {
            if (!isOpen.value)
                return;
            const userEdited = tagsChanged(selectedTags.value, initialTags.value);
            if (userEdited)
                return;
            const startTags = Array.isArray(next) ? [...next] : [];
            selectedTags.value = startTags;
            initialTags.value = [...startTags];
        }, { deep: true });
        function applyAndClose() {
            const classification = selectedTagData.value?.classification;
            if (!classification) {
                isOpen.value = false;
                return;
            }
            emit('apply', {
                classification,
                alwaysApply: alwaysApply.value,
                excludeFromAnalysis: excludeFromAnalysis.value,
                alwaysApplyExcludeInclude: alwaysApplyExcludeInclude.value,
                tags: [...selectedTags.value],
            });
            // Close immediately — the parent revalidates the transaction in the
            // background while the lozenge skeleton on TransactionDetailPage signals
            // the in-flight update.
            isOpen.value = false;
        }
        function openDrawer() {
            isOpen.value = true;
        }
        function closeDrawer() {
            isOpen.value = false;
        }
        __expose({ openDrawer, closeDrawer });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createBlock(SimpleDrawerPanel, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((isOpen).value = $event)),
                title: "Change category",
                height: "90vh",
                closeButton: true
            }, {
                footer: _withCtx(() => [
                    (!excludeDialogVisible.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["cc-toggle-row", { dimmed: !categoryChanged.value }])
                                }, [
                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "cc-toggle-label" }, "Always apply to this merchant", -1)),
                                    _createVNode(MGToggle, {
                                        modelValue: alwaysApply.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((alwaysApply).value = $event))
                                    }, null, 8, ["modelValue"])
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["cc-toggle-row", { dimmed: !selectedTag.value }])
                                }, [
                                    _cache[15] || (_cache[15] = _createElementVNode("span", { class: "cc-toggle-label" }, "Exclude merchant from Spending Analysis", -1)),
                                    _createVNode(MGToggle, {
                                        modelValue: excludeFromAnalysis.value,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((excludeFromAnalysis).value = $event))
                                    }, null, 8, ["modelValue"])
                                ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(MGButton, {
                                    text: "Update",
                                    fullWidth: true,
                                    disabled: !hasChanges.value,
                                    onClick: applyAndClose
                                }, null, 8, ["disabled"])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                    (excludeDialogVisible.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("p", _hoisted_2, [
                                _createTextVNode(_toDisplayString(excludeFromAnalysis.value ? 'Exclude' : 'Include') + " transaction", 1),
                                _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                _createTextVNode("Would you like to always " + _toDisplayString(excludeFromAnalysis.value ? 'exclude' : 'include') + " transactions", 1),
                                (_ctx.merchantName)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _cache[5] || (_cache[5] = _createTextVNode(" from ")),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.merchantName), 1)
                                    ], 64))
                                    : _createCommentVNode("", true),
                                _cache[8] || (_cache[8] = _createTextVNode("?"))
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(MGButton, {
                                    text: `Yes, always ${excludeFromAnalysis.value ? 'exclude' : 'include'}`,
                                    fullWidth: true,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (confirmAlwaysExcludeInclude(true)))
                                }, null, 8, ["text"]),
                                _createVNode(MGButton, {
                                    text: "No, just this once",
                                    fullWidth: true,
                                    onClick: _cache[1] || (_cache[1] = ($event) => (confirmAlwaysExcludeInclude(false)))
                                }),
                                _createElementVNode("button", {
                                    class: "cc-cancel",
                                    onClick: cancelExcludeChange
                                }, "Back")
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (!excludeDialogVisible.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: cat.key,
                                    class: _normalizeClass(["cc-cat-item", { dimmed: selectedCategory.value && selectedCategory.value !== cat.key, selected: selectedCategory.value === cat.key }]),
                                    onClick: ($event) => (selectCategory(cat.key))
                                }, [
                                    _createElementVNode("div", {
                                        class: "cc-cat-circle",
                                        style: _normalizeStyle({ background: cat.colour })
                                    }, [
                                        (cat.iconPath)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "cc-cat-icon",
                                                src: cat.iconPath
                                            }, null, 8, _hoisted_6))
                                            : (_openBlock(), _createBlock(_component_v_icon, {
                                                key: 1,
                                                size: "24",
                                                color: "white"
                                            }, {
                                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                    _createTextVNode("mdi-tag-outline")
                                                ])),
                                                _: 1
                                            }))
                                    ], 4),
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["cc-cat-label", { bold: selectedCategory.value === cat.key }])
                                    }, _toDisplayString(cat.label), 3)
                                ], 10, _hoisted_5));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true),
                    (selectedCategoryData.value && !excludeDialogVisible.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "cc-tags-title" }, "Categories", -1)),
                            _createElementVNode("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayTags.value, (tag) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                        key: tag.name,
                                        class: _normalizeClass(["cc-tag", { selected: selectedTag.value === tag.name }]),
                                        onClick: ($event) => (selectTag(tag))
                                    }, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["cc-tag-dot", { tick: selectedTag.value === tag.name }]),
                                            style: _normalizeStyle({ background: tagDotColour(tag) })
                                        }, [
                                            (selectedTag.value === tag.name)
                                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                                    key: 0,
                                                    size: "10",
                                                    color: "white"
                                                }, {
                                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                        _createTextVNode("mdi-check")
                                                    ])),
                                                    _: 1
                                                }))
                                                : _createCommentVNode("", true)
                                        ], 6),
                                        _createTextVNode(" " + _toDisplayString(tag.name), 1)
                                    ], 10, _hoisted_9));
                                }), 128))
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (selectedTag.value && !excludeDialogVisible.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "cc-tag-heading" }, "Add a transaction tag", -1)),
                            _createVNode(TagInput, {
                                selectableTags: _ctx.selectableTags ?? [],
                                modelValue: selectedTags.value,
                                maxTags: 5,
                                maxTagLength: 20,
                                placeholder: "Tag limit reached — remove one to add another",
                                chipsBelow: true,
                                onChange: handleTagsChange
                            }, null, 8, ["selectableTags", "modelValue"]),
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "cc-tag-help" }, "Find your transaction tags on the Activity page. Try using them to group transactions from a holiday, or project.", -1))
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
